import React from 'react'
import {Button, Icon} from '@therms/atalaya'
import {MdAccessTime, MdEdit} from 'react-icons/md'

interface SectionEditButtonProps {
  onClick: () => void
}

export function SectionEditButton({onClick}: SectionEditButtonProps) {
  return (
    <Button onClick={onClick} size="xs" subtle variant="neutral">
      <Icon Icon={MdEdit} size="sm" />
    </Button>
  )
}

export function PendingApprovalPill() {
  return (
    <span className="bg-caution-faded text-color-caution gap-xxs px-xs py-xxs inline-flex items-center rounded-full text-xs font-semibold whitespace-nowrap">
      <Icon Icon={MdAccessTime} size="xs" />
      Pending approval
    </span>
  )
}

interface SectionShellProps {
  action?: React.ReactNode
  children: React.ReactNode
  title: string
}

export function SectionShell({action, children, title}: SectionShellProps) {
  return (
    <div>
      <div className="border-border gap-sm pb-xs mb-base flex items-center border-b">
        <span className="text-color-subtle text-xs font-semibold tracking-widest uppercase">
          {title}
        </span>
        <div className="flex-1" />
        {action}
      </div>
      {children}
    </div>
  )
}
